import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerProveedores() {
    var url = ConfigAPI.baseURL + "suppliers" + Session.getToken();
    return instance.get(url);
  }, 

  importarSuppliersProductosPrices(data, file) {    
    var headers = {
      'Content-Type': 'multipart/form-data'
    }

    var formData = new FormData();
    data = JSON.parse(data)
    for ( var key in  data) {
      if(key!="file") {
        formData.append(key, data[key]);
      }

      if(key=="file") {                
        file.forEach((value, key) => {          
          formData.append('file', value);
        })
      }      
    }

    var params = formData
    var url = ConfigAPI.baseURL + "costs/suppliers-products/import/CSV" + Session.getToken();
    
    return instance.post(url,params,{headers});
  },    

  obtenerProveedoresOnlyImport(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/filter/suppliers" + Session.getToken();
    return instance.post(url,params);    
  },
  obtenerProveedoresForTree(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/filter/treeSuppliers" + Session.getToken();
    return instance.post(url,params);    
  },
  obtenerProductsByFilter(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/filter/treeQuery" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);        
  },
  exportForCSV(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/filter/exportForCSV" + Session.getToken();
    return instance.post(url,params);
  },
  
  activarProductsSale(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/product-sale/active" + Session.getToken();
    return instance.post(url,params);        
  },
  inactivarProductsSale(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/product-sale/inactive" + Session.getToken();
    return instance.post(url,params);        
  },

  obtenerLista() {
    var url = ConfigAPI.baseURL + "price-list" + Session.getToken();
    return instance.get(url);
  },  
  saveProduct(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/convert" + Session.getToken();
    
    return instance.post(url,params);    
  },
  buscarProductoCostosPorCodigoBarras(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-barcode/search" + Session.getToken();
    return instance.post(url, params);
  },
  cargarProductoCostosPorId(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-barcode/search" + Session.getToken();
    return instance.post(url, params);
  },
  buscarProductosCostosPorTexto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-text/search" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerOpcionesProductoCostosPorCodigoBarras() {
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-barcode/options" + Session.getToken();
    return instance.get(url);
  },
  mostrarProductosByLista(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products/filter/showProducts" + Session.getToken();
    return instance.post(url,params);
  },
  marcarDefault(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/setDefault" + Session.getToken();
    return instance.post(url,params); 
  },
  updateProducto(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/update" + Session.getToken();
    return instance.post(url,params);
  },      
  deleteProducto(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/delete" + Session.getToken();
    return instance.post(url,params);
  },        
  compareProductos(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/filter/compare" + Session.getToken();
    return instance.post(url,params);
  },

  sincroPrice(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/sincro-price" + Session.getToken();
    return instance.post(url,params); 
  },  
  undoPrice(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/undo-price" + Session.getToken();
    return instance.post(url,params); 
  },  

  obtenerImportListCost(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products-import" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },
  obtenerImportDetailListCost(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products-import/show" + Session.getToken();
    return instance.post(url,params);
  },

  updateProductoLote(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/updateLot" + Session.getToken();
    return instance.post(url,params);
  },
  updateProductoDescuentoLote(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products/updateDiscountLot" + Session.getToken();
    return instance.post(url,params);
  },
  
  filtrarOrdenesDeCompra(data, page) {
    var params = data
    var url = ConfigAPI.baseURL + "purchase-orders/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url, params);
  },
  agregarOrdenDeCompra(data) {
    var params = data
    var url = ConfigAPI.baseURL + "purchase-orders" + Session.getToken();
    return instance.post(url, params);
  },
  agregarItemOrdenDeCompra(orderId, data) {
    var params = data
    var url = ConfigAPI.baseURL + "purchase-orders/" + orderId + "/append-item" + Session.getToken();
    return instance.post(url, params);
  },

  obtenerStockPorProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "deposits-stock-count/search" + Session.getToken();
    return instance.post(url, params);
  },

  procesarAjustesStock(data) {
    var params = data
    var url = ConfigAPI.baseURL + "deposits-stock-count/process" + Session.getToken();
    return instance.post(url, params);
  },

  obtenerCondicionesIva() {
    var url = ConfigAPI.baseURL + "sales-iva-conditions" + Session.getToken();
    return instance.get(url);
  },

  obtenerConfiguracion() {
    var url = ConfigAPI.baseURL + "costs-configuration" + Session.getToken();
    return instance.get(url);
  },
  obtenerUnidadesMedida() {
    var url = ConfigAPI.baseURL + "products-unit-measurement" + Session.getToken();
    return instance.get(url);
  },
  saveConfiguracion(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs-configuration/" + data.id + Session.getToken();
    return instance.post(url, params);
  },

  obtenerUpdateExternalListCost(page) {
    var params = []    
    var url = ConfigAPI.baseURL + "costs/suppliers-products-update-external" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },  
  anularUpdateExternalListCost(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "costs/suppliers-products-update-external/undo" + Session.getToken();
    return instance.post(url,params);
  },

  agregarPrecioListaProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products" + Session.getToken();
    return instance.post(url,params);
  },
  editarPrecioListaProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products-item/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarPrecioListaProducto(id, data = {}) {
    var url = ConfigAPI.baseURL + "price-list-products/" + id + Session.getToken();
    return instance.delete(url, { data: data });
  },

  forzarSnapshotPrecios() {
    var url = ConfigAPI.baseURL + "price-list-products/force-snapshot" + Session.getToken();
    return instance.post(url);
  },
}

export default servicesAPI;
